import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "message content is-danger" }
const _hoisted_2 = { class: "message-body" }
const _hoisted_3 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (this.title != null)
        ? (_openBlock(), _createElementBlock("strong", _hoisted_3, _toDisplayString(this.title), 1))
        : _createCommentVNode("", true),
      _createElementVNode("ul", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.failures, ([key, value]) => {
          return (_openBlock(), _createElementBlock("li", { key: key }, [
            _createTextVNode(_toDisplayString(key) + " ", 1),
            _createElementVNode("ul", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(value, (failure) => {
                return (_openBlock(), _createElementBlock("li", { key: failure }, _toDisplayString(failure), 1))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ])
  ]))
}